import { useState } from "react";

export const usePagination = (
  initialPageSize: number = 50
): {
  pageIndex: number;
  pageSize: number;
  changePageIndex(pageIndex: number): void;
  changePageSize(pageSize: number): void;
} => {
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(initialPageSize);

  return {
    pageIndex,
    pageSize,
    changePageIndex: (pageIndex: number) => setPageIndex(pageIndex),
    changePageSize: (pageSize: number) => {
      setPageIndex(0);
      setPageSize(pageSize);
    }
  };
};
